// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cl-2";
export var aiChatCartContainerExit = "_cl-4";
export var aiChatContainerLarge = "_cl-0";
export var aiChatContainerSmall = "_cl-1";
export var aiChatIcon = "_cl-6";
export var slideInFromRight = "_cl-3";
export var slideOutToRight = "_cl-5";